import "core-js/modules/es6.function.name";
//
//
//
export default {
  name: 'ParentView',
  data: function data() {
    return {
      cacheChaildName: ''
    };
  },
  computed: {
    notCacheName: function notCacheName() {
      return this.$route.meta && this.$route.meta.notCache ? this.$route.name : '';
    }
  }
};